import { styled, Button } from "@mui/material";

import HNSColors from "../../ui library/HNSColors";

export const ContainedRoundedButton = styled(Button)({
  borderRadius: "500px",
  textTransform: "none",
  fontWeight: 400,
  fontSize: "14px",
  boxShadow: "none",
  paddingLeft: 3,
  paddingRight: 3,
  minWidth: 220,
  height: 40,
  background: HNSColors.secondary[500],
  "&:hover": { background: HNSColors.secondary[600] },
  variant: "contained",
  color: HNSColors.neutrals[900],
  "&:disabled": {
    background: HNSColors.neutrals[800],
    color: HNSColors.neutrals[500],
  },
});

export const OutlinedRoundedButton = styled(Button)({
  borderRadius: "500px",
  textTransform: "none",
  fontWeight: 400,
  fontSize: "14px",
  boxShadow: "none",
  paddingLeft: 3,
  paddingRight: 3,
  minWidth: 220,
  height: 40,
  background: HNSColors.neutrals[900],
  border: `1px solid ${HNSColors.secondary[500]}`,
  "&:hover": { background: HNSColors.neutrals[800] },
  variant: "outlined",
  color: HNSColors.secondary[500],
  "&:disabled": {
    background: HNSColors.neutrals[800],
    color: HNSColors.neutrals[500],
  },
});
